import React from "react";
import OrderPickerCard, { SecondOrderPickerCard } from "./orderPickerCard";

const OrderPickers = () => {
  return (
    <div className="w-full mt-5">
      <h4 className="mt-8 text-xl">Vychystávací vozíky</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <OrderPickerCard
          imgSrc="/images/ClarkOverview/clark-cop1.webp"
          imgAlt="Obrázek vychystávacího vozíku CLARK cop1"
          title="CLARK COP1"
          bottomShelterLoadCapacity="110 kg"
          topShelterLoadCapacity="90 kg"
          liftHeight="2 990 mm"
          drive="Elektrický"
          maxSpeed="až 6 km/h"
          link="https://clarkmheu-com.translate.goog/en/order-picker/cop1?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />

        <SecondOrderPickerCard
          imgSrc="/images/ClarkOverview/clark-cop2.webp"
          imgAlt="Obrázek vychystávacího vozíku CLARK cop2"
          title="CLARK COP2"
          loadCapacity="363 kg"
          liftHeight="4 880 mm"
          drive="Elektrický"
          maxSpeed="až 5.5 km/h"
          link="https://clarkmheu-com.translate.goog/en/order-picker/cop2?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
          sameHeightAsIfAdditionalInfo="4.2rem"
        />
      </div>
    </div>
  );
};
export default OrderPickers;
